module.exports = __webpack_public_path__ + "img/btn-sign-in-g.a277af45.svg";